var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-text",class:[_vm.styleClassName, _vm.sizeClassName],attrs:{"disabled":_vm.disabled}},[_c('span',{staticClass:"button-text__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }